import React, { Suspense, useEffect } from 'react';
import Header from '../../Header';
import Main from '../../Main';
import OuterWrap from '../OuterWrap';
import * as S from './Styled';
import useWindowHeight from '../../../hooks/useWindowHeight';

const MapPage = ({ layout = 'fullscreen-layout', style, sidebar, map }) => {
  useWindowHeight();

  useEffect(() => {
    const body = document.querySelector('body');

    if (layout) {
      body.classList.add(layout);
    }

    return () => {
      const classList = body.classList;
      while (classList.length) {
        classList.remove(classList.item(0));
      }
    };
  }, [layout]);

  return (
    <OuterWrap>
      <Suspense fallback={<div>Загрузка...</div>}>
        <Header layout={layout} />
      </Suspense>
      <Main style={style}>
        <S.Container>
          <S.Sidebar>{sidebar}</S.Sidebar>
          <S.Map>{map}</S.Map>
        </S.Container>
      </Main>
    </OuterWrap>
  );
};

export default MapPage;
